export default "__VITE_ASSET__97b9af11__"